<div class="editable-table-container mt-1">
  <div class="table-responsive">
    <irembogov-editable-table
      [rows]="rows"
      [columns]="columns"
      [formControl]="formControl"
      [disabled]="field.props?.disabled || false"
      [customTableClass]="field.props['customTableClass'] || ''"
      [showRowLabels]="field.props['showRowLabels'] ?? false"
      [rowColumnTitle]="field.props['rowColumnTitle'] || ''"
      [allowRowAddition]="field.props['allowRowAddition'] ?? false"
      [allowRowDeletion]="field.props['allowRowDeletion'] ?? false"
      (cellValueChanged)="
        handleCellValueChange($event.rowKey, $event.columnKey, $event.value)
      ">
    </irembogov-editable-table>
  </div>

  <ng-container *ngIf="formControl.invalid && formControl.touched">
    <div class="text-danger mt-2">
      <small *ngIf="formControl.errors?.['required']">
        {{ 'Field is required' | translate }}
      </small>
      <small *ngIf="formControl.errors?.['custom']">
        {{ formControl.errors?.['custom'] | translate }}
      </small>
    </div>
  </ng-container>
</div>
